import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../../artist-help/profile/styles.css';

export default function ProfileCollectorHelpArtistsAndGalleriesPage() {
  const t = useTranslations('collectors_help.artists_and_galleries');
  const [openSections, setOpenSections] = useState({
    howArtistsJoin: false,
    inventoryStatus: false,
    galleryVsArtist: false,
    benefitsForArtists: false,
    followingArtists: false,
    verifiedInsignia: false,
    supportArtists: false,
    artistsCanCollect: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category">
      <header className="artist-help-category__header">
        <GoBackButton alternativeRoute="/profile/collector-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('howArtistsJoin')}
            aria-expanded={openSections.howArtistsJoin}
          >
            <h2>{t('sections.how_artists_join.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.howArtistsJoin ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.howArtistsJoin && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.how_artists_join.p1')}</p>
              <ul>
                <li>{t('sections.how_artists_join.list_1')}</li>
                <li>{t('sections.how_artists_join.list_2')}</li>
                <li>{t('sections.how_artists_join.list_3')}</li>
              </ul>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('inventoryStatus')}
            aria-expanded={openSections.inventoryStatus}
          >
            <h2>{t('sections.inventory_status.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.inventoryStatus ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.inventoryStatus && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.inventory_status.p1')}</p>
              <ul>
                <li>{t('sections.inventory_status.list_1')}</li>
                <li>{t('sections.inventory_status.list_2')}</li>
              </ul>
              <p>{t('sections.inventory_status.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('galleryVsArtist')}
            aria-expanded={openSections.galleryVsArtist}
          >
            <h2>{t('sections.gallery_vs_artist.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.galleryVsArtist ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.galleryVsArtist && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.gallery_vs_artist.p1')}</p>

              <div className="artist-help-category__stack">
                <h3>{t('sections.gallery_vs_artist.galleries_title')}</h3>
                <p>{t('sections.gallery_vs_artist.galleries_p1')}</p>
                <ul>
                  <li>{t('sections.gallery_vs_artist.galleries_list_1')}</li>
                  <li>{t('sections.gallery_vs_artist.galleries_list_2')}</li>
                  <li>{t('sections.gallery_vs_artist.galleries_list_3')}</li>
                  <li>{t('sections.gallery_vs_artist.galleries_list_4')}</li>
                  <li>{t('sections.gallery_vs_artist.galleries_list_5')}</li>
                </ul>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.gallery_vs_artist.artists_title')}</h3>
                <p>{t('sections.gallery_vs_artist.artists_p1')}</p>
                <ul>
                  <li>{t('sections.gallery_vs_artist.artists_list_1')}</li>
                  <li>{t('sections.gallery_vs_artist.artists_list_2')}</li>
                  <li>{t('sections.gallery_vs_artist.artists_list_3')}</li>
                  <li>{t('sections.gallery_vs_artist.artists_list_4')}</li>
                  <li>{t('sections.gallery_vs_artist.artists_list_5')}</li>
                </ul>
              </div>

              <div className="artist-help-category__note">
                <h3>{t('sections.gallery_vs_artist.note_title')}</h3>
                <p>{t('sections.gallery_vs_artist.note_p1')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('benefitsForArtists')}
            aria-expanded={openSections.benefitsForArtists}
          >
            <h2>{t('sections.benefits_for_artists.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.benefitsForArtists ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.benefitsForArtists && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.benefits_for_artists.p1')}</p>
              <ul>
                <li>{t('sections.benefits_for_artists.list_1')}</li>
                <li>{t('sections.benefits_for_artists.list_2')}</li>
                <li>{t('sections.benefits_for_artists.list_3')}</li>
                <li>{t('sections.benefits_for_artists.list_4')}</li>
              </ul>
              <p>{t('sections.benefits_for_artists.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('followingArtists')}
            aria-expanded={openSections.followingArtists}
          >
            <h2>{t('sections.following_artists.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.followingArtists ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.followingArtists && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.following_artists.p1')}</p>
              <ul>
                <li>{t('sections.following_artists.list_1')}</li>
                <li>{t('sections.following_artists.list_2')}</li>
              </ul>
              <p>{t('sections.following_artists.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('verifiedInsignia')}
            aria-expanded={openSections.verifiedInsignia}
          >
            <h2>{t('sections.verified_insignia.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.verifiedInsignia ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.verifiedInsignia && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.verified_insignia.p1')}</p>
              <p>{t('sections.verified_insignia.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('supportArtists')}
            aria-expanded={openSections.supportArtists}
          >
            <h2>{t('sections.support_artists.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.supportArtists ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.supportArtists && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.support_artists.p1')}</p>

              <div className="artist-help-category__stack">
                <h3>{t('sections.support_artists.support_title')}</h3>
                <p>{t('sections.support_artists.support_p1')}</p>
                <ul>
                  <li>{t('sections.support_artists.support_list_1')}</li>
                  <li>{t('sections.support_artists.support_list_2')}</li>
                  <li>{t('sections.support_artists.support_list_3')}</li>
                </ul>
              </div>

              <div className="artist-help-category__stack">
                <h3>{t('sections.support_artists.subscriptions_title')}</h3>
                <p>{t('sections.support_artists.subscriptions_p1')}</p>
                <ul>
                  <li>{t('sections.support_artists.subscriptions_list_1')}</li>
                  <li>{t('sections.support_artists.subscriptions_list_2')}</li>
                </ul>
                <p>{t('sections.support_artists.subscriptions_p2')}</p>
              </div>

              <div className="artist-help-category__note">
                <h3>{t('sections.support_artists.note_title')}</h3>
                <ul>
                  <li>{t('sections.support_artists.note_list_1')}</li>
                  <li>{t('sections.support_artists.note_list_2')}</li>
                </ul>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger"
            onClick={() => toggleSection('artistsCanCollect')}
            aria-expanded={openSections.artistsCanCollect}
          >
            <h2>{t('sections.artists_can_collect.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon ${openSections.artistsCanCollect ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.artistsCanCollect && (
            <div className="artist-help-category__accordion-content">
              <p>{t('sections.artists_can_collect.p1')}</p>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
